import { render } from "./Ventamodal.vue?vue&type=template&id=4a692380&scoped=true"
import script from "./Ventamodal.vue?vue&type=script&lang=js"
export * from "./Ventamodal.vue?vue&type=script&lang=js"

import "./Ventamodal.vue?vue&type=style&index=0&id=4a692380&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a692380"]])

export default __exports__